import React from "react";

function ToolbarHeader({ title, type }) {
    return (
        <div className={`fw-${type}-header`}>{title}</div>
    );
}

export { ToolbarHeader };
